import unlockedFeaturesDataset from "../datasets/unlocked_features_dataset";
import checkIfEligibleForUnlockedFeature from "./check_if_eligible_for_unlocked_feature";


export const checkForNewUnlockedFeatures = (gameMonths, cashAmt, monthlyIncome,
    unlockedFeatures, totalGameMonths, annualSalary, creditReport) => {
    
    // unlockedFeaturesDataset is a list of all unlocked features, their levels and the
    // basic eligible criteria
    let unlockedFeaturesList = unlockedFeaturesDataset;
    let gameMonthsPlayed = +totalGameMonths - +gameMonths;
    let newUnlockedFeature = {};
    let changed = false;  
    let newFeatureName = "";
    let prevLevel = null;
    let prevFeature = "";
    
    for (let i=0; i<unlockedFeaturesList.length; i++){
        let featureName = unlockedFeaturesList[i].featureName; 
        let unlockedFeatureObj = unlockedFeatures.find(elem => elem.featureName === featureName);
        // if unlocked feature from list exists and the level is less than the one on the list
        let unlockedFeatureLevelFound = false;
        if (unlockedFeatureObj && unlockedFeatureObj.level <= unlockedFeaturesList[i].level){
            unlockedFeatureLevelFound = true;
        }
        //  if previous level for same feature was not eligible, skip all following levels for this feature
        let previousFeatureValid = false;
        if ((featureName === prevFeature && prevLevel === true) || (featureName !== prevFeature)){
            previousFeatureValid = true;
        }
        // select the unlocked feature from the list if both of preceding conditions are true or
        // if the one on the list is not found in the unlocked feature table.
        if ((unlockedFeatureLevelFound && previousFeatureValid) || (!unlockedFeatureObj)){
            const eligibleForFeature = 
                checkIfEligibleForUnlockedFeature(gameMonthsPlayed, cashAmt, monthlyIncome,
                    annualSalary, unlockedFeaturesList[i], unlockedFeatureObj, creditReport);
            prevFeature = featureName;
            if (eligibleForFeature === true){ 
                prevLevel = true;
                if (!unlockedFeatureObj){
                    newUnlockedFeature = {featureName: unlockedFeaturesList[i].featureName, 
                        setup: "none", level: unlockedFeaturesList[i].level}
                    changed = true;
                    unlockedFeatures.push(newUnlockedFeature);
                    newFeatureName = featureName;    
                }else{
                    if (unlockedFeaturesList[i].level > unlockedFeatureObj.level){
                        changed = true;
                        // if the previous level of the feature has never been accepted, then change level number
                        //      but no new notification will happen
                        // if the previous level of the feature has been activated, the level will change and  
                        //      setup will be set to "none" - this will force a notification but will not affect the
                        //      previous level's information.
                        unlockedFeatureObj.level = unlockedFeaturesList[i].level;
                        unlockedFeatureObj.setup = "none";
                    }
                }
            }else{
                prevLevel = false;
            }
        }
    }
   
    let featureObj = {unlockedFeatures: unlockedFeatures, changed: changed, newFeature: newFeatureName};
    return featureObj;
   
}





